import React, { useEffect, useMemo, useRef, useState } from 'react';
import { api } from '../api';

export default function FeatureTags({ appUuid, value, onChange, placeholder = 'добавьте особенности' }) {
  const [input, setInput] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  const normalized = useMemo(() => (value || []).map((v) => String(v).trim()).filter(Boolean), [value]);

  useEffect(() => {
    (async () => {
      try {
        const res = await api.get(`/features/suggest?app_uuid=${encodeURIComponent(appUuid || '')}`);
        const items = (res.items || []).map((it) => it.name).filter(Boolean);
        setSuggestions(items);
      } catch (_) {
        setSuggestions([]);
      }
    })();
  }, [appUuid]);

  useEffect(() => {
    const onDocClick = (e) => {
      if (!containerRef.current) return;
      if (!containerRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('click', onDocClick);
    return () => document.removeEventListener('click', onDocClick);
  }, []);

  const filtered = useMemo(() => {
    const q = input.trim().toLowerCase();
    if (!q) return suggestions.filter((s) => !normalized.includes(s)).slice(0, 8);
    return suggestions.filter((s) => s.toLowerCase().includes(q) && !normalized.includes(s)).slice(0, 8);
  }, [input, suggestions, normalized]);

  const addTag = (tag) => {
    const t = String(tag || '').trim();
    if (!t) return;
    if (normalized.includes(t)) return;
    onChange([...(normalized || []), t]);
    setInput('');
    setOpen(false);
  };

  const removeTag = (tag) => {
    onChange((normalized || []).filter((x) => x !== tag));
  };

  const onKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ',' || e.key === 'Tab') {
      e.preventDefault();
      addTag(input);
    } else if (e.key === 'Backspace' && !input) {
      onChange((normalized || []).slice(0, -1));
    }
  };

  return (
    <div ref={containerRef} className="border rounded p-2 bg-white">
      <div className="flex flex-wrap gap-2">
        {normalized.map((tag) => (
          <span key={tag} className="inline-flex items-center gap-1 px-2 py-1 bg-blue-50 text-blue-700 rounded text-xs">
            {tag}
            <button type="button" className="text-blue-500 hover:text-blue-700" onClick={() => removeTag(tag)} aria-label={`Удалить ${tag}`}>×</button>
          </span>
        ))}
        <input
          className="flex-1 min-w-[140px] outline-none p-1 text-sm"
          placeholder={placeholder}
          value={input}
          onChange={(e) => { setInput(e.target.value); setOpen(true); }}
          onKeyDown={onKeyDown}
          onFocus={() => setOpen(true)}
        />
      </div>
      {open && filtered.length > 0 && (
        <div className="mt-2 border rounded bg-white shadow-sm max-h-40 overflow-auto">
          {filtered.map((s) => (
            <button key={s} type="button" className="w-full text-left px-3 py-2 text-sm hover:bg-gray-50" onClick={() => addTag(s)}>
              {s}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}